import { useMutation, useQueryClient } from '@tanstack/react-query';
import { getSubdomain } from '@zealy/utils';
import { getMe } from '../../services/utils';
import { notificationsKeys } from '../notifications.keys';
import { patchNotifications } from '../notifications.service';
export const useUpdateNotificationStatus = (subdomain = getSubdomain(), userId = getMe() ?? 'me') => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (body) => {
            const resolvedUserId = await Promise.resolve(userId);
            return patchNotifications({
                params: {
                    subdomain,
                    userId: resolvedUserId,
                },
                body,
            });
        },
        onSuccess: async (data) => {
            const resolvedUserId = await Promise.resolve(userId);
            queryClient.invalidateQueries({
                queryKey: notificationsKeys.notifications(subdomain, resolvedUserId),
            });
        },
    });
};
